import { render, staticRenderFns } from "./MessageDocument.vue?vue&type=template&id=6e8c3fbc&"
import script from "./MessageDocument.vue?vue&type=script&lang=js&"
export * from "./MessageDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports